'use strict';

var _markupMenu = require('./markup-menu');

var _main = require('./main');

var _main2 = _interopRequireDefault(_main);

var _animations = require('./components/animations');

var _animations2 = _interopRequireDefault(_animations);

var _sliders = require('./components/sliders');

var _sliders2 = _interopRequireDefault(_sliders);

var _header = require('./components/header');

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _markupMenu.markupMenu)(window.document);


$(document).ready(function () {
  (0, _main2.default)();
  (0, _animations2.default)();
  (0, _sliders2.default)();
  (0, _header2.default)();
  svg4everybody();
  jcf.setOptions('Select', {
    wrapNativeOnMobile: false,
    wrapNative: false,
    fakeDropInBody: false
  });
  jcf.replaceAll();
});


//////////////////
// WEBPACK FOOTER
// ./app/scripts/index.js
// module id = 0
// module chunks = 0